// extracted by mini-css-extract-plugin
export default {"icon-animation":"Fudy987eLTdiWKB2IVe_","common_bganimation":"vvpieUti2dJKKLCCrLTD"};